var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.125rem",
    height: "1.125rem",
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33203 1.73438V26.001H21.6654V1.73438H4.33203ZM9.5068 21.5306H6.91778V19.4032H9.5068V21.5306ZM9.5068 17.4861H6.91778V15.3588H9.5068V17.4861ZM9.5068 13.4417H6.91778V11.3143H9.5068V13.4417ZM9.5068 9.18424H6.91778V7.05686H9.5068V9.18424ZM9.5068 5.1398H6.91778V3.01242H9.5068V5.1398ZM14.4227 21.5306H11.8336V19.4032H14.4227V21.5306ZM14.4227 17.4861H11.8336V15.3588H14.4227V17.4861ZM14.4227 13.4417H11.8336V11.3143H14.4227V13.4417ZM14.4227 9.18424H11.8336V7.05686H14.4227V9.18424ZM14.4227 5.1398H11.8336V3.01242H14.4227V5.1398ZM19.3385 21.5306H16.7495V19.4032H19.3385V21.5306ZM19.3385 17.4861H16.7495V15.3588H19.3385V17.4861ZM19.3385 13.4417H16.7495V11.3143H19.3385V13.4417ZM19.3385 9.18424H16.7495V7.05686H19.3385V9.18424ZM19.3385 5.1398H16.7495V3.01242H19.3385V5.1398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/Employment.28d2f026bbb82ff4954c4876852c7889.svg";
export { ForwardRef as ReactComponent };